<template>
  <div>
    <template v-if="isLoading">
      <LoadingSpinner is-bg-sand />
    </template>

    <template v-if="isSuccess">
      <div class="u-pad-h--4">
        <ProductFilter v-if="filter" v-model="selectedValue" :filter-mode="filterMode" :options="renderedList" />
      </div>

      <ProductListItem
        :array-list="renderedList"
        :products="products"
        :selected-value="selectedValue"
        :filter="filter"
        :filter-mode="filterMode"
      />
    </template>
    <template v-if="isError">
      <div class="u-mrgn-top--3 u-mrgn-h--4 u-txt--medium">
        Gagal memuat data, <a @click="getProducts">muat ulang</a>
      </div>
    </template>
  </div>
</template>

<script>
import LoadingSpinner from 'shared/components/LoadingSpinner';
import productListMixin from 'shared/mixins/productListMixin';
import ProductFilter from './ProductFilter';
import ProductListItem from './ProductListItem';

export default {
  name: 'ProductList',
  components: {
    ProductFilter,
    ProductListItem,
    LoadingSpinner,
  },
  mixins: [productListMixin],
};
</script>
